import { render, staticRenderFns } from "./AcceptSection.vue?vue&type=template&id=574ec4cb&"
import script from "./AcceptSection.vue?vue&type=script&lang=js&"
export * from "./AcceptSection.vue?vue&type=script&lang=js&"
import style0 from "./AcceptSection.vue?vue&type=style&index=0&id=574ec4cb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports